import { useState } from 'react';
import toast from 'react-hot-toast';
import { getErrorString, isEmptyArray } from '../../../utils';
import { changeTicketAssignee, fetchAvailableAssigns } from '../../../api/leads-api';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../../hooks';
import { PERMISSIONS_STRUCT } from '../../../constants/permissions';
import ChangeAssigneeBody from './ChangeAssigneeBody';

const ChangeAssignee = ({ ticketData, onSuccessResolve }) => {
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const { getPermission } = usePermissions();
  const { data: userData } = useSelector((store) => store.userData);

  const canChangeAssignee = () => {
    const hasPermission = getPermission({
      models: PERMISSIONS_STRUCT.TICKET.NAME,
      actions: PERMISSIONS_STRUCT.TICKET.ACTIONS.ASSIGN_TICKET,
    });

    if (!hasPermission) return false;
    if (ticketData?.resolver?.id) return false;
    if (userData?.roles?.[0]?.name === 'agent') {
      if (ticketData?.assignee?.id) return ticketData?.team?.team_lead?.id == userData?.id;
    }
    return true;
  };
  const isAllowed = canChangeAssignee();

  const fetchUsers = async (forceFetch = false) => {
    if (!isEmptyArray(users) && !forceFetch) return;
    if (!isAllowed) return;
    try {
      setLoader(true);
      const response = await fetchAvailableAssigns(ticketData?.id, { per_page: 300 });
      if (response?.status) {
        setUsers(response?.data);
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setLoader(false);
    }
  };

  return (
    <ChangeAssigneeBody
      data={ticketData}
      isAllowed={isAllowed}
      fetchUsers={fetchUsers}
      users={users}
      loader={loader}
      onSuccess={onSuccessResolve}
      changeFunc={changeTicketAssignee}
    />
  );
};

export default ChangeAssignee;
